import { useMemo } from 'react';
import { DAY_WIDTH_PX } from './monthlyLayoutConstants';
import { getMonthSectionWidthPx } from './getVisibleDayColumns';
import type { MonthDescriptor } from './types';

export type MonthSectionWidth = {
  month: MonthDescriptor;
  widthPx: number;
  isExpanded: boolean;
};

export function useMonthSectionWidths(
  months: MonthDescriptor[],
  expandedMonths: string[],
  isCompact: boolean
): MonthSectionWidth[] {
  return useMemo(
    () =>
      months.map(month => {
        const isExpanded = expandedMonths.includes(month.key);
        return {
          month,
          isExpanded,
          widthPx: getMonthSectionWidthPx(
            month.daysInMonth,
            isExpanded,
            isCompact,
            DAY_WIDTH_PX
          )
        };
      }),
    [months, expandedMonths, isCompact]
  );
}

export function sumMonthSectionWidths(
  monthSections: MonthSectionWidth[]
): number {
  return monthSections.reduce((total, section) => total + section.widthPx, 0);
}
